<template>
    <div class="pa-5 ma-3 white rounded-lg">
        <div class="subheading grey--text mb-9">Lead List</div>

        <v-row>
            <v-col cols="6" offset="6" class="pt-0">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
            </v-col>
        </v-row>
        
        <v-data-table :headers="headers" :items="items" :footer-props="paginationOptions" :search="search"
            item-key="id" :options="pagination" :loading="loading" @click:row="toLeadDetails" @pagination="onPagination">
            <template v-slot:item.phone="{ item }">
                {{ formatPhoneNum( item.phone ) }}
            </template>
            <template v-slot:item.event_date="{ item }">
                {{ formatDate( item.event_date ) }}
            </template>
            <template v-slot:item.date_created="{ item }">
                {{ formatDate( item.date_created, 'YYYY-MM-DD @ hh:mm a' ) }}
            </template>
            <template v-slot:item.contacted="{ item }">
                {{ item.contacted == 1 ? 'Yes' : 'No' }}
            </template>
        </v-data-table>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { _st } from '@/softech';

export default {
    data: () => ({
        headers     : [
            { text: 'ID', value: 'id', sortable: true },
            { text: 'Full Name', value: 'full_name', sortable: true },
            { text: 'Phone', value: 'phone', sortable: true },
            { text: 'Email', value: 'email', sortable: true },
            { text: 'Event', value: 'event_name', sortable: true },
            { text: 'Event Date', value: 'event_date', sortable: true },
            { text: 'Event Type', value: 'event_type', sortable: true },
            { text: 'Contacted', value: 'contacted', sortable: true },
            { text: 'Created On', value: 'date_created', sortable: true },
        ],
        pagination: {
            sortBy: ['orderDate']
        },
        paginationOptions: { itemsPerPageOptions: [ 25, 50, -1 ] },
        loading: false,
        search: '',
    }),
    computed: {
        ...mapGetters({
            items       : 'leads/leads',
            hasMore     : 'leads/hasMore',
            needRefresh : 'leads/needRefresh'
        })
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            loadLeads: 'leads/loadLeads'
        }),
        async init() {
            try {
                if( !this.needRefresh )
                    return; 

                this.loading = true;
                await this.loadLeads();
                this.loading = false;
            }
            catch(error) {
                this.loading = false;
            }
        },
        formatDate(d, f = 'YYYY-MM-DD') {
            if( _st.isNUE( d ) )
                return '';

            return moment(d).format(f);
        },
        onPagination(v) {
            if( v.pageCount != v.page || this.search != '' ) {
                return;
            }

            this.loadMore();
        },
        async loadMore() {
            try {
                if( !this.hasMore )
                    return;
                
                this.loading = true;
                await this.loadLeads();
                this.loading = false;
            }
            catch(error) {
                this.loading = false;
            }
        },
        toLeadDetails(item) {
            this.$router.push(`/leads/${item.id}`);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>